import { apiClient } from "../../../../lib/api-client";
import { WorksheetResult } from "../types/WorksheetResult";
import { WorksheetType } from "../types/WorksheetType";

export async function apiGetWorksheet(retailOrderID: number, worksheetType: WorksheetType): Promise<WorksheetResult> {
	try {
		return await apiClient.get("retail-order/worksheet",
			{
				params: { retailOrderID, worksheetType }
			}) as WorksheetResult;
	} catch (error: any) {
		return {
			isSuccess: false,
			errorMessage: 'Error happened when downloading the document'
		};
	}
};
